import { Actions, SERIAL_NUMBER_ACTION_TYPES } from "../actions"
import { DefaultState } from "./types"
import { StateHandler } from "./handler"

const defaultState: DefaultState = {
    listing: [],
    isLoading: false,
    error: "",
}

function reducer(state = defaultState, action: Actions) {
    const handler = StateHandler(state)

    switch (action.type) {
    case SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING:
        return handler.fetchListing()
    case SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING_SUCCESS:
        return handler.fetchListingSuccess(action.payload)
    case SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING_ERROR:
        return handler.fetchListingError(action.payload)
    case SERIAL_NUMBER_ACTION_TYPES.CLEAR_SERIAL_NUMBER_LISTING:
        return handler.clearListing()
    default:
        return state
    }
}

export {
    defaultState,
    reducer
}



// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/reducers/reducer.ts